export const boardRows = [
    [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
    [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
    [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]
    ];
    
    export const columns = ['2 to 1', '2 to 1', '2 to 1']
    export const dozens = ['1st 12', '2nd 12', '3rd 12']
    export const oodEven = ['Odd', 'Even']
    export const colors = ['Red', 'Black', 'Green' ]
    export const hightLow = ['1-18', '19-36']
    export const sectors = [
        {text: '32,15,19,4,21,2', color: '#FD0081'},
        {text: '25,17,34,6,27,13', color: '#FF0202'},
        {text: '36,11,30,8,23,10', color: '#6CFF00'},
        {text: '5,24,16,33,1,20', color: '#00EBE3'},
        {text: '14,31,9,22,18,29', color: '#0B00FF'}, 
        {text: '7,28,12,35,3,26', color: '#FBE001'}]
    
    export const neighbors = [
        {text: '0', value:"3/26/0/32/15", color: 'green', col:14},
    
        [{text: '32', value:"26/0/32/15/19", color: '#CF1818', col:1},
        {text: '15', value:"0/32/15/19/4", color: '#202020', col:1},
        {text: '19', value:"32/15/19/4/21", color: '#CF1818', col:1},
        {text: '4', value:"15/19/4/21/2", color: '#202020', col:1}, 
        {text: '21', value:"19/4/21/2/25", color: '#CF1818', col:1},
        {text: '2', value:"4/21/2/25/17", color: '#202020', col:1},
        {text: '25', value:"21/2/25/17/34", color: '#CF1818', col:1},
        {text: '17', value:"2/25/17/34/6", color: '#202020', col:1},
        {text: '34', value:"25/17/34/6/27", color: '#CF1818', col:1},
        {text: '6', value:"17/34/6/27/13", color: '#202020', col:1},
        {text: '27', value:"34/6/27/13/36", color: '#CF1818', col:1},
        {text: '13', value:"6/27/13/36/11", color: '#202020', col:1},
        {text: '36', value:"27/13/36/11/30", color: '#CF1818', col:1},
        {text: '11', value:"13/36/11/30/8", color: '#202020', col:1},
        {text: '30', value:"36/11/30/8/23", color: '#CF1818', col:1},
        {text: '8', value:"11/30/8/23/10", color: '#202020', col:1},
        {text: '23', value:"30/8/23/10/5", color: '#CF1818', col:1}],
    
        [{text: '26', value:"35/3/26/0/32", color: '#202020', col:1},
        {text: '3', value:"12/35/3/26/0", color: '#CF1818', col:1},
        {text: '35', value:"28/12/35/3/26", color: '#202020', col:1},
        {text: '12', value:"7/28/12/35/3", color: '#CF1818', col:1},
        {text: '28', value:"29/7/28/12/35", color: '#202020', col:1},
        {text: '7', value:"18/29/7/28/12", color: '#CF1818', col:1},
        {text: '29', value:"22/18/29/7/28", color: '#202020', col:1},
        {text: '18', value:"9/22/18/29/7", color: '#CF1818', col:1},
        {text: '22', value:"31/9/22/18/29", color: '#202020', col:1},
        {text: '9', value:"14/31/9/22/18", color: '#CF1818', col:1},
        {text: '31', value:"20/14/31/9/22", color: '#202020', col:1},
        {text: '14', value:"1/20/14/31/9", color: '#CF1818', col:1},
        {text: '20', value:"33/1/20/14/31", color: '#202020', col:1},
        {text: '1', value:"16/33/1/20/14", color: '#CF1818', col:1},
        {text: '33', value:"24/16/33/1/20", color: '#202020', col:1},
        {text: '16', value:"5/24/16/33/1", color: '#CF1818', col:1},
        {text: '24', value:"10/5/24/16/33", color: '#202020', col:1}],
    
        {text: '10', value:"8/23/10/5/24", color: '#202020', col:1},
        {text: '5', value:"23/10/5/24/16", color: '#CF1818', col:1},
        ]
    
    export const betTypes = {
        columns : 7,
        dozens: 8,
        oddEven: 9,
        colors: 10,
        hightLow: 11,
        sectors: 12,
        neighbors: 13
    }
    
    const x = undefined;
    export const oddFieldsRows = [
      [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]
    , [x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]]
    
    
    export const options = {
         1: {
            'number': { 
                value: 1
            },
            'split0' : {
                value : '0, 1',
                position: 'left'
            },
            'split2': {
                value: '1, 2',
                position: 'pop',
            },
            'split4': {
                value: '1, 4',
                position: 'right'
            },
            '3line': {
                value: '1, 2, 3',
                position: 'bottom'
            },
            'corner1245': {
                value: '1, 2, 4, 5',
                position: 'topRight'
            },
            '6line':{
                value: '1, 2, 3, 4, 5, 6',
                position: 'bottomRight'
            },
            'four': {
                value: '1, 2, 3, 4',
                position: 'bottomLeft'
            }
        }
    }
    